import { supabase } from "@/integrations/supabase/client";

export type SeoSettings = Record<string, string>;

/** İlkin (fallback) SEO dəyərləri — baza əlçatmaz olsa belə sayt SEO-su işləyir. */
export const SEO_DEFAULTS: SeoSettings = {
  home_title: "Albazar.az — pulsuz elan saytı: mənzil, ev, maşın, telefon",
  home_description:
    "Albazar.az — Azərbaycanın pulsuz elan saytı. Mənzil, ev, bağ evi, maşın, avtomobil, telefon və iş elanları. Pulsuz elan yerləşdir, sürətli sat.",
  home_keywords:
    "albazar, albazar.az, pulsuz elan saytı, elan saytı, mənzil elanları, maşın elanları, telefon elanları, iş elanları, Bakı elanlar",
  category_title_template: "{kateqoriya} elanları — Albazar.az",
  category_description_template:
    "{kateqoriya} kateqoriyasında Azərbaycan üzrə ən yeni elanlar. Qiymət və şəhərə görə seçin.",
  category_keywords_template: "{kateqoriya}, {kateqoriya} elanları, {kateqoriya} Bakı, albazar.az",
  listing_title_template: "{basliq} Satılır – {qiymet} | Albazar.az",
  listing_description_template:
    "{seher}da satılan {basliq} elanına baxın. Qiymət: {qiymet}. Şəkillər və satıcı məlumatları Albazar.az-da.",
  listing_keywords_template: "{basliq}, {kateqoriya}, {seher} elanları, albazar.az",
  global_keywords: "albazar, elan saytı, pulsuz elan, Azərbaycan elanlar",
};

export const SEO_LABELS: Record<string, string> = {
  home_title: "Ana səhifə — Title",
  home_description: "Ana səhifə — Description",
  home_keywords: "Ana səhifə — açar sözlər",
  category_title_template: "Kateqoriya Title şablonu",
  category_description_template: "Kateqoriya Description şablonu",
  category_keywords_template: "Kateqoriya açar sözləri",
  listing_title_template: "Elan Title şablonu",
  listing_description_template: "Elan Description şablonu",
  listing_keywords_template: "Elan açar sözləri",
  global_keywords: "Ümumi açar sözlər",
};

/** Şablondakı {açar} yerlərini doldurur. */
export function renderSeo(template: string, vars: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (_m, k: string) => vars[k] ?? "").replace(/\s+/g, " ").trim();
}

/** SEO ayarlarını oxuyur; xəta olsa ilkin dəyərlər qaytarılır. */
export async function fetchSeoSettings(): Promise<SeoSettings> {
  try {
    const { data, error } = await supabase.from("seo_settings").select("key, value").limit(200);
    if (error || !data) return { ...SEO_DEFAULTS };
    const out: SeoSettings = { ...SEO_DEFAULTS };
    for (const row of data as { key: string; value: string | null }[]) {
      if (row.value && row.value.trim()) out[row.key] = row.value;
    }
    return out;
  } catch {
    return { ...SEO_DEFAULTS };
  }
}

export async function saveSeoSetting(key: string, value: string) {
  const { error } = await supabase
    .from("seo_settings")
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: "key" });
  if (error) throw error;
}
